import React, { FC } from 'react'
import { DefaultStockType, ScheduleType } from 'types/schedule'
import { DefaultStockForm, DaysOfWeekPicker, HoursToDeadlineForm } from './index'
import { Spacer } from 'components/Utility'
import { FlexColumn, FlexRow } from 'components/Flex'
import { SelectDaysOfWeekButton, TextButton } from 'components/Button'
import { FirebaseDocRefType } from 'firebase/index'
import { DayOfWeekType } from 'lib/daysOfWeek'
import { StockUnionType } from 'types/stock'
import { FormLabel } from 'components/Label'
import { SubDescription } from 'components/Typography'

type Props = {
  addDefaultStock: (ref: FirebaseDocRefType, type: StockUnionType) => void
  deleteDefaultStock: (ref: FirebaseDocRefType, defaultStockIndex: number, type: StockUnionType) => void
  deleteSchedule: (index: number, type: StockUnionType) => void
  handleDefaultStocks: (
    defaultStock: DefaultStockType,
    index: number,
    scheduleRef?: FirebaseDocRefType,
    type?: StockUnionType
  ) => void
  handleHoursToDeadline?: (dateToDeadline: string, timeToDeadline: string, ref?: FirebaseDocRefType) => void
  isShownDeleteIcon: boolean
  schedule: ScheduleType
  index: number
  selectableDaysOfWeek: DayOfWeekType[]
  selectDaysOfWeek: (dayOfWeek: DayOfWeekType, index: number, type: StockUnionType | '') => void
  selectAllDaysOfWeek: () => void
  unselectAllDaysOfWeek: () => void
  type: StockUnionType
}

const DefaultStockFormWrapper: FC<Props> = (props) => {
  const {
    addDefaultStock,
    deleteDefaultStock,
    deleteSchedule,
    handleDefaultStocks,
    handleHoursToDeadline,
    isShownDeleteIcon,
    schedule,
    index,
    selectableDaysOfWeek,
    selectDaysOfWeek,
    selectAllDaysOfWeek,
    unselectAllDaysOfWeek,
    type,
  } = props

  return (
    <>
      <FlexRow justifyContent={'center'}>
        <SelectDaysOfWeekButton
          daysOfWeek={schedule.days_of_week}
          unselectAll={unselectAllDaysOfWeek}
          selectAll={selectAllDaysOfWeek}
        />
      </FlexRow>
      <Spacer size={12} />
      <DaysOfWeekPicker
        daysOfWeek={schedule.days_of_week}
        index={index}
        selectDaysOfWeek={(dayOfWeek: DayOfWeekType) => selectDaysOfWeek(dayOfWeek, index, type)}
        selectableDaysOfWeek={selectableDaysOfWeek}
        type={type}
        wrap={true}
      />
      <Spacer size={16} />
      <DefaultStockForm
        daysOfWeek={schedule.days_of_week}
        defaultStocks={schedule.default_stocks}
        deleteDefaultStock={deleteDefaultStock}
        deleteSchedule={deleteSchedule}
        handleDefaultStocks={handleDefaultStocks}
        isShownDeleteIcon={isShownDeleteIcon}
        index={index}
        scheduleRef={schedule.schedule_ref}
        type={type}
      />
      <Spacer size={16} />
      <FlexColumn alignItems={'center'}>
        {schedule.default_stocks.some((defaultStock) => defaultStock.pickupable_time === '') ||
        schedule.days_of_week.length === 0 ? (
          <TextButton
            disabled={true}
            iconPath={'/icon/grey/plus.svg'}
            label={'受渡解禁時刻を追加する'}
            onClick={() => addDefaultStock(schedule.schedule_ref!, type)}
          />
        ) : (
          <TextButton
            iconPath={'/icon/blue/plus.svg'}
            label={'受渡解禁時刻を追加する'}
            onClick={() => addDefaultStock(schedule.schedule_ref!, type)}
          />
        )}
      </FlexColumn>
      <Spacer size={16} />
      {handleHoursToDeadline && (
        <>
          <FormLabel label={'注文締め切り'} required={true} />
          <Spacer size={8} />
          <SubDescription description={'お客様が、アプリ上で購入できる締切日です。'} />
          <Spacer size={8} />
          <HoursToDeadlineForm
            daysOfWeek={schedule.days_of_week}
            handleHoursToDeadline={handleHoursToDeadline}
            prevHoursToDeadline={schedule.hours_to_deadline}
            scheduleRef={schedule.schedule_ref}
          />
        </>
      )}
      <Spacer size={16} />
    </>
  )
}

export default DefaultStockFormWrapper
